import SkeletonBase from "newui/components/Skeleton";
import { RFX_SUBMISSION_STATUS } from "../../constants";
import { RfxSubmissionStatus } from "../../types/submission.type";
import { HStack } from "@chakra-ui/react";
import { Icon } from "assets/Icon";
import { formattedSimpleDate } from "utils/dateFormat";

interface RfxSubmissionStatusPillProps {
	className?: string;
	size?: "p-2" | "p-3" | "p-4";
	submissionDate?: any;
	submissionStatus: RfxSubmissionStatus;
}

const responseStatuses = [
	{
		displayText: "Submitted",
		color: "#00976B",
		colorBorder: "#00A87C",
		type: RFX_SUBMISSION_STATUS.SUBMITTED,
	},
	{
		displayText: "In Progress",
		color: "#0031DD",
		colorBorder: "#003CE9",
		type: RFX_SUBMISSION_STATUS.INPROGRESS,
	},
	{
		displayText: "Declined",
		color: "#B42318",
		colorBorder: "#D92D20",
		type: RFX_SUBMISSION_STATUS.DECLINE,
	},
	{
		displayText: "Awarded",
		color: "#00976B",
		colorBorder: "#00A87C",
		type: RFX_SUBMISSION_STATUS.AWARDED,
	},
	{
		displayText: "Invited",
		color: "#0031DD",
		colorBorder: "#003CE9",
		type: RFX_SUBMISSION_STATUS.INVITED,
	},
	{
		displayText: "Accepted",
		color: "#00976B",
		colorBorder: "#00A87C",
		type: RFX_SUBMISSION_STATUS.ACCEPTED,
	},
	{
		displayText: "Unsuccessful",
		color: "#B42318",
		colorBorder: "#D92D20",
		type: RFX_SUBMISSION_STATUS.UNSUCCESSFUL,
	},
	{
		displayText: "Being Revised",
		color: "#0031DD",
		colorBorder: "#003CE9",
		type: RFX_SUBMISSION_STATUS.BEING_REVISED,
	},
];

export const RfxSubmissionStatusPill: React.FC<
	RfxSubmissionStatusPillProps
> = ({ className, submissionDate, size, submissionStatus }) => {
	if (!submissionStatus) {
		return <SkeletonBase />;
	}

	const status = responseStatuses.find(
		(status) => status.type === submissionStatus.toUpperCase()
	);

	const dateDisplay = (
		<div className="mt-1 block text-xs">
			<HStack>
				<Icon
					icon="calendar"
					color="#0031DD"
					class="aling-middle -mt-[2px] mr-1 inline-block w-[12px]"
				/>
				<div>
					{status.type !== RFX_SUBMISSION_STATUS.SUBMITTED && (
						<>
							Submitted <br />
						</>
					)}
					{formattedSimpleDate(submissionDate)}
				</div>
			</HStack>
		</div>
	);

	return (
		<div>
			<div
				className={`${className} ${size !== undefined ? size : "p-3"} flex items-center justify-center rounded-full bg-white text-center font-roboto text-[14px] font-medium shadow-sm`}
				style={{
					width: "fit-content",
					color: status.color,
					border: `solid 1.5px ${status.colorBorder}`,
					height: "24px",
				}}
			>
				{status.displayText}
			</div>
			{submissionDate && dateDisplay}
		</div>
	);
};
